import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import {
  UnorderedListOutlined,
  ScheduleOutlined,
  HistoryOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";

const ToDoMenu = (props) => {
  const { onChangeMenuFilter, filters } = props;
  const intl = useIntl();
  const [selectedKeys, setSelectedKeys] = useState(["1"]);

  useEffect(() => {
    if (filters.due_date && !filters.starred) {
      let selectedKey = "1";
      switch (filters.due_date) {
        case "all":
          selectedKey = "1";
          break;
        case "lastTwoWeeks":
          selectedKey = "5";
          break;
        case "today":
          selectedKey = "3";
          break;
        case "overdue":
          selectedKey = "4";
          break;
        case "nextWeek":
          selectedKey = "5";
          break;
        default:
          break;
      }
      setSelectedKeys([selectedKey]);
    }
  }, [filters]);

  const getItem = (label, key, icon, children, type) => {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  };
  const items = [
    getItem(
      intl.formatMessage({
        id: "app.todolist.all",
      }),
      "1",
      <UnorderedListOutlined />
    ),
    getItem(
      intl.formatMessage({
        id: "app.todolist.starred",
      }),
      "2",
      <StarOutlined />
    ),
    getItem(
      intl.formatMessage({
        id: "app.todolist.due_today",
      }),
      "3",
      <ScheduleOutlined />
    ),
    getItem(
      intl.formatMessage({
        id: "app.todolist.overdue",
      }),
      "4",
      <HistoryOutlined />
    ),
  ];

  const onSelect = ({ key }) => {
    setSelectedKeys([key]);
    let filter = null;
    switch (key) {
      case "1":
        filter = "all";
        break;
      case "2":
        filter = "starred";
        break;
      case "3":
        filter = "today";
        break;
      case "4":
        filter = "overdue";
        break;
      default:
        break;
    }
    onChangeMenuFilter(filter);
  };

  return (
    <Menu
      mode="inline"
      defaultSelectedKeys={["1"]}
      style={{
        borderRight: 0,
      }}
      items={items}
      selectedKeys={selectedKeys}
      onSelect={onSelect}
    />
  );
};

export default ToDoMenu;
